/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { ApplicationStartup } from '@tivocorp/tivo-webapp-loggers';
import { AppStartOperationsLogger, VuLogger } from '../../core/logging';
import {
    PARTNER_BRANDING_LOGO_WIDTH_1080P,
    PARTNER_BRANDING_LOGO_HEIGHT_1080P,
} from '../../config';
import { DefaultServicesClientImpl } from '../../core/impls/DefaultServiceClientImpl';
import { MsoDefaultBrandingUiBundleService } from '../../core/infrastructure/MsoDefaultBrandingUiBundleService';
import { SlsServiceGlobalEndpointsService } from '../../core/infrastructure/SlsServiceGlobalEndpointsService';
import { setPartnerBrandingImageUrlAction } from '../appl/appl.actions';
import { showSplashScreen } from '../screens/screens.reducers';
import {
    hideErrorOverlay,
    showTemporaryServiceConnectionIssueOverlay,
} from '../error/erroroverlays.reducers';
import {
    EmptyResponseError,
    PartialResponseError,
    SlsGlobalEndpointError,
    MsoDefaultBrandingError,
} from '../../core/error';

const TAG = 'presignin';
export const prepareForAppLaunch = () => async (dispatch: Function) => {
    ApplicationStartup.info(TAG, 'Inside prepareForAppLaunch');
    const defaultServices = new DefaultServicesClientImpl();

    try {
        ApplicationStartup.info(TAG, 'Fetch SlsGlobalEndpoints');
        AppStartOperationsLogger.logStartSlsGlobalEndpointsGet();

        await defaultServices.fetchSlsGlobalEndpoints();

        AppStartOperationsLogger.logSlsGlobalEndpointsSuccessful();
    } catch (error: any) {
        let serviceError = error;
        if (!(error instanceof PartialResponseError || error instanceof EmptyResponseError)) {
            const slsError: any = error?.response?.data;
            serviceError = new SlsGlobalEndpointError(slsError?.code, slsError?.message);
        }
        dispatch(showTemporaryServiceConnectionIssueOverlay(serviceError));
        ApplicationStartup.error(TAG, 'Failed to fetch SlsGlobalEndpoints', error);
        AppStartOperationsLogger.logSlsGlobalEndpointsFailed(serviceError);
        ApplicationStartup.info(TAG, 'Wait for SlsGlobalEndpoints to recover');
        VuLogger.logLoginFailureEvent(serviceError);

        await defaultServices.waitForSlsGlobalEndpoints();
        dispatch(hideErrorOverlay());

        AppStartOperationsLogger.logSlsGlobalEndpointsRestoration();
    }

    try {
        MsoDefaultBrandingUiBundleService.initialize(
            SlsServiceGlobalEndpointsService.getServiceEndpointByServiceName(
                SlsServiceGlobalEndpointsService.MSO_DEFAULT_BRANDING_SERVICE,
            ),
        );
        ApplicationStartup.info(TAG, 'Fetch MsoDefaultBrandingUiInfo');
        AppStartOperationsLogger.logMsoDefaultBrandingUiBundleGet();
        await defaultServices.fetchMsoDefaultBrandingUiInfo();

        AppStartOperationsLogger.logMsoDefaultBrandingUiBundleSuccessful();
    } catch (error: any) {
        const brandingServiceError = error?.response?.data;
        const brandingUiBundleError = new MsoDefaultBrandingError(
            brandingServiceError?.code,
            brandingServiceError?.message,
        );
        ApplicationStartup.error(TAG, 'Failed to fetch MsoDefaultBrandingUiInfo', error);
        AppStartOperationsLogger.logMsoDefaultBrandingUiBundleFailed(brandingUiBundleError);
    } finally {
        dispatch(showSplashScreen());
        const partnerBrandingImageUrl1080p = defaultServices.getPartnerBrandingImageUrl(
            PARTNER_BRANDING_LOGO_WIDTH_1080P,
            PARTNER_BRANDING_LOGO_HEIGHT_1080P,
        );
        dispatch(setPartnerBrandingImageUrlAction(partnerBrandingImageUrl1080p));
    }
};
